import React from "react";
import { Switch, Route } from "react-router-dom";

import WorkOrdersPage from "./WorkOrdersPage";
import WorkOrderPage from "./WorkOrderPage";

const WorkOrdersRouter = () => (
  <Switch>
    <Route path="/fleet/work-orders/:id">
      <WorkOrderPage />
    </Route>
    <Route path="/fleet/work-orders">
      <WorkOrdersPage />
    </Route>
  </Switch>
);

export default WorkOrdersRouter;
